export enum InstallationMethods {
    CART_SNIPPET = "Cart Snippet",
    CHECKOUT_SNIPPET = "Checkout Snippet",
    APP_BLOCK = "App Block",
    JS_API = "JS API",
    TU_PRE_CHECKOUT = "TU Pre-checkout",
    TU_IN_CHECKOUT = "TU In-checkout",
}
